import React from 'react';
import Luckysheet from "../../component/LuckySheet";

export default function Sheet(){

    return (
        <Luckysheet></Luckysheet>
    )
}